import ky from 'ky';
import { FormParameters } from './form.service';
import Yup from './validation.service';

export const WhitepaperFormValidation = Yup.object({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  company: Yup.string().required(),
  email: Yup.string().required(),
}).strict();

export type Values = Yup.InferType<typeof WhitepaperFormValidation>;

export async function submitForm(values: Values, formParameters: FormParameters): Promise<any> {
  return ky.post('/web-v2/api/form', {
    json: { values, formParameters },
    searchParams: { type: 'whitepaper' },
  });
}
